// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-1lInW","checkbox_checked":"checkbox_checked-h0uJK"};